import { MatDialog } from "@angular/material/dialog";
import { Component, OnInit, HostListener, Input, Output, EventEmitter } from "@angular/core";
import { ReportTypes } from "src/app/reports/enums/report-types";
import { ReportFactoryService } from "src/app/reports/services/report-factory.service";
import { DispatchesService } from "src/app/despachos/shared/services/dispatches.service";
import { ZoneService } from "./../../../zone/services/zone.service";


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  verNav: boolean = false;
  headerColor: boolean = false;

  @Input() nav: boolean = false;
  @Input() notificaciones: boolean = false;
  @Input() notificationsNotSeen: number = 0;
  @Input() configuraciones: boolean = false;
  @Output() clickVerNav = new EventEmitter<boolean>();
  @Output() verNotificaciones = new EventEmitter<boolean>();
  @Output() verConfiguraciones = new EventEmitter<boolean>();

  @HostListener("window:scroll", ["$event"])
  doSomethingOnWindowsScroll($event: any) {
    this.headerColor = $event.srcElement.children[0].scrollTop > 10;
  }

  constructor(
    private reportFactory: ReportFactoryService,
    private dispatchService: DispatchesService,
  ) {}

  ngOnInit(): void {}

  clickNav(valor: boolean) {
    this.nav = valor;
    this.clickVerNav.emit(valor);
    localStorage.setItem("nav", `${valor}`);
  }

  verMisNotificaciones() {
    this.verNotificaciones.emit(!this.notificaciones);
  }

  verMiConfiguracion() {
    this.verConfiguraciones.emit(!this.configuraciones);
  }

  generateExcelRetirement() {
    this.dispatchService.getAllPendingToWithdraw().subscribe((dispatches) => {
      this.reportFactory.setType(ReportTypes.RETIREMENT)!.generate(dispatches);
    });
  }

  async generateExcelDeliver() {
    this.dispatchService.getAllPendingToWithdraw().subscribe((dispatches) => {
      this.reportFactory.setType(ReportTypes.DELIVER)!.generate(dispatches);
    });
  }
}
